import { cn } from "@/lib/utils";

interface BadgeProps {
  children: React.ReactNode;
  variant?: "default" | "primary" | "secondary" | "outline" | "success";
  className?: string;
}

export function Badge({ 
  children, 
  variant = "default",
  className 
}: BadgeProps) {
  const variants = {
    default: "bg-neutral-100 text-neutral-700 border-neutral-200",
    primary: "bg-primary-blue/10 text-primary-blue border-primary-blue/20",
    secondary: "bg-primary-orange/10 text-primary-orange border-primary-orange/20",
    outline: "bg-transparent border border-neutral-300 text-neutral-600",
    success: "bg-green-100 text-green-700 border-green-200",
  };

  return (
    <span 
      className={cn(
        "inline-flex items-center px-3 py-1 rounded-full text-[11px] font-bold uppercase tracking-wide border",
        variants[variant],
        className
      )}
    >
      {children}
    </span>
  );
}
